<template>
    <Teleport to="body" :disabled="!portal">
        <div
            v-bind="$attrs"
            :class="[
                modalClass,
                'modal fade modal-location-override',
                { 'modal-top-level': topLevelModal }
            ]"
            ref="modal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog" :class="`${modalSizeClass} ${animationClass}`">
                <div v-if="$slots.title" class="panel panel-color panel-inverse m-0">
                    <div class="panel-heading">
                        <button v-if="showCloseButton" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h3 class="panel-title">
                            <slot name="title"></slot>
                        </h3>
                    </div>
                </div>

                <div
                    class="modal-content"
                    :class="{'p-0 overflow-hidden': noPadding}"
                >
                    <div class="modal-body p-0">
                        <button
                            v-if="!$slots.title"
                            type="button"
                            class="bg-transparent absolute z-10 right-0 text-white opacity-100 border-0 btn-xl text-shadow hover:opacity-75"
                            data-dismiss="modal"
                            aria-hidden="true"
                        >×
                        </button>
                        <slot></slot>
                    </div>

                    <div v-if="$slots.footer" class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: 'Modal',

    props: {
        value: {
            default: false,
            type: Boolean,
        },

        size: {
            default: 'md',
            type: String,
            validator: value => ['xs', 'sm', 'md', 'lg', 'xl', '2xl', 'full'].includes(value),
        },

        noPadding: {
            default: false,
            type: Boolean,
        },

        // If the modal should be mounted outside of the "component tree". This would be the preferred behavior
        // for all new modal components. However, to not introduce breaking change, we default to `false`, to
        // keep exiting modal components as is, and we may migrate older modals over time.
        portal: {
            default: false,
            type: Boolean,
        },

        // If the modal should be a top-level modal, meaning it will be displayed above other modals.
        topLevelModal: {
            default: false,
            type: Boolean,
        },

        modalClass: {
            default: '',
            type: String,
        },

        showCloseButton: {
            default: true,
            type: Boolean,
        },

        animationClass: {
            default: '',
            type: String,
        }
    },

    computed: {
        modalSizeClass() {
            return this.size === 'md' ? '' : `modal-${this.size}`;
        }
    },

    methods: {
        showModal() {
            $(this.$refs.modal).modal('show');
        },

        hideModal() {
            $(this.$refs.modal).modal('hide');
        },

        onClose() {
            // Fix for common bootstrap modal issue:
            // Remove 'aside' class from other modals when this one closes
            this.$nextTick(() => {
                $('.modal-dialog.aside').removeClass('aside');
            });

            this.$emit('input', false);
        },
    },

    mounted() {
        this.$nextTick(() => {
            $(this.$refs.modal).on('hide.bs.modal', this.onClose)
        });
    },

    beforeUnmount() {
        $(this.$refs.modal).off('hide.bs.modal', this.onClose)
    },

    watch: {
        value(value) {
            if (value) {
                this.showModal();
            } else {
                this.hideModal();
            }
        },
    }
}
</script>

<style scoped>
.modal-location-override {
	z-index: 1051;
}

.modal-top-level {
    z-index: 1052;
}
</style>
